import { computed } from 'vue';
import { useRemoteConfigStore } from '../stores/remoteConfig.store';
import { useAccountStore } from '@/stores/account';

/**
 * Validates if the current user can access stablecoin payout features based on
 * the feature flag and optional whitelist from Firebase Remote Config.
 *
 * - enabled: true → allow ALL users (whitelist is ignored)
 * - enabled: false + whitelist empty → block all users
 * - enabled: false + whitelist with IDs → allow only those customer IDs
 */
export function usePayoutStablecoins() {
  const remoteConfigStore = useRemoteConfigStore();
  const accountStore = useAccountStore();

  const config = remoteConfigStore.getRemoteConfigValue(
    'feature_payout_stablecoins'
  );

  const isEnabled = computed<boolean>(() => {
    const { enabled, whitelist } = config.value;

    if (enabled) return true;
    if (!whitelist || whitelist.length === 0) return false;

    const customerId = String(
      accountStore.kycStatus?.company?.id ?? ''
    );

    return whitelist.includes(customerId);
  });

  return {
    isEnabled,
    config,
  };
}
